import { render, staticRenderFns } from "./KemudahanAsasBase.vue?vue&type=template&id=5691f1f7&scoped=true"
import script from "./KemudahanAsasBase.vue?vue&type=script&lang=js"
export * from "./KemudahanAsasBase.vue?vue&type=script&lang=js"
import style0 from "./KemudahanAsasBase.vue?vue&type=style&index=0&id=5691f1f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5691f1f7",
  null
  
)

export default component.exports